import React, { useEffect, useState } from "react";
import PopupModal from "../../common/PopupModal";
import "./mfa.scss";
import brighterTextLogo from "../../assets/images/brighterTextLogo.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProviderAuthenticateWhileLogin,
  fetchUpdatePhoneNumber,
} from "../../store/Login/LoginActions";
import FloatingLabelInput from "./FloatingLabelInput";
// import device from "./assets/Icons/devicesbluecheckmark.svg";
import device from "../../assets/Icons/devicesbluecheckmark.svg";

const Mfa = ({ loginDetails, onMfaSuccess, onMfaClose }) => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [showError, setShowError] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const dispatch = useDispatch();

  const { userDetailsPinError, updatePhoneNumberSuccess } = useSelector(
    (state) => state.loginUserDetails
  );

  useEffect(() => {
    setShowError(true);
    setTimeout(() => {
      setShowError(false);
    }, 20000);
  }, [userDetailsPinError]);

  useEffect(() => {
    if (updatePhoneNumberSuccess) {
      setIsModalOpen(false);
      if (onMfaSuccess) {
        onMfaSuccess();
      }
    }
  }, [updatePhoneNumberSuccess, onMfaSuccess]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    if (onMfaClose) {
      onMfaClose();
    }
  };

  const handleSubmit = (formData) => {
    const data = {
      userName: loginDetails?.userName,
      phoneNumber: formData?.number,
      "X-DeviceFP": "d485dbc29097bda4b5bc5b8325f5af46f2b036be678",
    };
    dispatch(fetchUpdatePhoneNumber(data)).then(() => {
      dispatch(fetchProviderAuthenticateWhileLogin(loginDetails));
    });
  };

  const RenderLoginContent = () => {
    return (
      <div className="login-info-content">
        <div className="row">
          <img
            className="brighterLogo"
            src={brighterTextLogo}
            alt="Brighter Logo"
          />
        </div>
        <div className="row mfa">
          <div className="col-md-8 borderRight">
            <h5 className="p-3">
              Multi-factor Authentication(MFA) is now required to access your
              Brighter account
            </h5>
            <p className="p-3">
              Enter the 10-digit phone number you wish to use for
              authentication. We will send you an SMS message with a
              verification pin to login.
            </p>
            <div className="otp-form-container">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  const data = {
                    number: phoneNumber,
                  };
                  handleSubmit(data);
                }}
                style={{ marginBottom: "20px" }}
              >
                <FloatingLabelInput
                  type="text"
                  name="number"
                  placeholder="###-###-####"
                  formatPhone={true}
                  className={
                    phoneNumber.length > 0 && phoneNumber.length !== 10
                      ? "red-border-input"
                      : ""
                  }
                  onKeyChangeCallback={(name, value) => {
                    setPhoneNumber(value);
                  }}
                />
                <button
                  type="submit"
                  className="saveBtn"
                  disabled={phoneNumber.length !== 10}
                  style={{
                    width: "auto",
                    padding: "8px 16px",
                    marginTop: "15px",
                  }}
                >
                  Submit
                </button>
              </form>
              <p className="assistance-text">
                If you need assistance, call us at 424-316-2534
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="pinMfaInfo">
              <img src={device} alt="Device" className="me-2 phoneIcon" />
              <p className="paraText">100% Secured</p>
              <p className="paraText">
                We take great care to protect your information.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const RenderErrors = () => {
    if (!showError) return null;
    return (
      <div className="alert alert-danger" role="alert">
        {userDetailsPinError}
      </div>
    );
  };

  return (
    <div className="login-wrapper">
      {RenderErrors()}
      {isModalOpen && (
        <PopupModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          customRender={RenderLoginContent}
          popupType="center"
          width="50%"
        />
      )}
    </div>
  );
};

export default Mfa;
